<template>
  <div class="italic pt-16">
    Laget av Sebastian Vittersø <a href="https://vitterso.net">🔗</a>
  </div>
</template>